'use strict';

import MainTemplate from 'commons/templates/HolidaysModal.ejs';
import ListTemplate from 'commons/templates/HolidaysList.ejs';
import RowTemplate from 'commons/templates/HolidaysRow.ejs';
import ModalTemplate from 'commons/templates/HolidaysAddModal.ejs';
import ModalFormView from 'commons/views/ModalForm.js';
import RowEditView from 'commons/views/RowEdit.js';
import ListEditablesView from 'commons/views/ListEditables.js';
import Holiday from 'newModels/holiday.js';

const RowView = RowEditView.extend({
    tagName: 'tr',

    events() {
        return Object.assign(RowEditView.prototype.events.apply(this), {
            'ifToggled .js-ext-toggle': 'toggle'
        });
    },

    initialize(options) {
        this.options = _.defaults(options || {}, {
            template:  RowTemplate,
            deletable: (app.company.id === this.model.get('companyId'))
        });

        this.location = options.additional.location;

        return RowEditView.prototype.initialize.apply(this, [this.options]);
    },

    render() {
        let r = RowEditView.prototype.render.apply(this, arguments);
        setTimeout(this.initializeControls.bind(this), 1);
        return r;
    },

    toggle(ev) {
        let $input = this.$(ev.currentTarget);
        let value = this.getInputValue($input);

        this.model.toggle(value, this.location);
    },

    initializeControls() {
        // The UI design has a weird placement for the delete button
        this.$('.form-control-with-delete').each((i, control) => {
            var $control = this.$(control);
            var $value = $control.find('.form-control-value');
            var $input = $control.find('.form-control');

            $value.css({
                display: 'inline-block',
                maxWidth: (
                    $input.width() -
                    $control.find('.btn-delete').outerWidth(true) - 5
                ) + 'px'
            }).text($input.val());

            $value.on('click', () => {
                $control.addClass('focus');
                $input.focus();
            });

            $input
                .on('keyup', ev => {
                    var val = this.$(ev.target).val();
                    $value.html(val);
                })
                .on('focus', () => { $control.addClass('focus'); })
                .on('blur', () => { $control.removeClass('focus'); });
        });
    }
});

const ModalView = ModalFormView.extend({
    initialize(options) {
        this.options = _.defaults(options || {}, {
            template: ModalTemplate
        });

        return ModalFormView.prototype.initialize.apply(this, [this.options]);
    }
});

const ListView = ListEditablesView.extend({
    itemViews: [],
    modalView: null,
    tagName: 'table',
    className: 'table table-striped table-settings',

    initialize(options) {
        this.options = Object.assign({
            template: ListTemplate,
            location: null,
            Model: Holiday,
            ModalEditView: ModalView,
            ModelView: RowView,
            unsubmittedPayroll: null,
            unsubmittedPayrollDetails: null
        }, options || {});

        return ListEditablesView.prototype.initialize.apply(
            this, [this.options]
        );
    },

    bindHandlers() {
        let r = ListEditablesView.prototype.bindHandlers.apply(this, []);

        if (this.modalEditView) {
            this.modalEditView.on('hide', this.restoreSelf, this);
            this.modalEditView.on('show', this.hideSelf, this);
        }

        return r;
    },

    createModel() {
        let model = ListEditablesView.prototype.createModel.apply(this, []);
        const include = (this.options.location.get('holidayStates') ||
            app.company.get('holidayStates')
        ).filter((name) => name !== 'national');
        model.set({
            description: '',
            include,
            isNational: false,
            companyId: app.company.id,
            companyLocationId: this.options.location.id,
            date: new Date()
        });
        return model;
    },

    restoreSelf() {
        this.trigger('show');
    },

    hideSelf() {
        this.trigger('hide');
    },

    showSelectModal() {
        var restoreSelf = function() {
            this.show();
            this.payrollItemSelectionModal.off('hide', restoreSelf);
        }.bind(this);

        this.hide();
        this.payrollItemSelectionModal.on('hide', restoreSelf);
        this.payrollItemSelectionModal.show();
    }
});

module.exports = ModalFormView.extend({
    events() {
        return Object.assign(ModalFormView.prototype.events(), {
            'click .js-add': 'add'
        });
    },

    initialize(options) {
        this.options = Object.assign({
            template: MainTemplate,
            location: null,
            templateExtra: {},
            actOnSave: false,
            actOnDestroy: false,
            actOnCancel: false
        }, options || {});

        this.listView = new ListView({
            collection: this.collection,
            location: this.options.location
        });
        this.listView.on('hide', this.hide, this);
        this.listView.on('show', this.show, this);
        this.listView.on('saved cancelled', this.hide, this);
        this.listView.on('saved', () => this.trigger('saved'));
        this.listView.on('save', () => this.trigger('save'));
        this.on('cancel', this.listView.cancel, this.listView);

        ModalFormView.prototype.initialize.apply(this, [this.options]);
        this.render();
        return this;
    },

    setLocation(location) {
        this.options.location = location;
        this.listView.options.location = location;
    },

    render() {
        if (!this.options.template) {
            return null;
        }

        if (!this.collection) {
            return this;
        }

        this.$el.html(this.options.template(this.options.templateExtra || {}));
        this.listView.render();
        this.$('.js-modal-body').append(this.listView.$el);
        this.listView.undelegateEvents();
        this.listView.delegateEvents();
        return this;
    },

    save(ev) {
        this.listView.save(ev);
    },

    add(ev) {
        if (this.listView) {
            this.listView.add(ev);
        }
        return this;
    },

    //disable
    markMandatoryFields() {},
    bindHandlers() {},
    unbindHandlers() {}
});



// WEBPACK FOOTER //
// ./app/commons/views/HolidaysModal.js